import type { Arrival, Cohort } from '@efdigital/ll-addon-data';
import { DataTypeXceed } from '@efdigital/ll-addon-data/data-types';
import type { Store } from '@warp-drive/core';

export function createDefaultArrival(store: Store, cohort: Cohort): Arrival {
  return store.createRecord<Arrival>(DataTypeXceed.Arrival, {
    cohort: cohort as unknown as Cohort,
    title: '',
    markdown: DEFAULT_ARRIVAL_MARKDOWN,
    location: 'ashridge-house',
    starts: '',
    ends: '',
    displayDate: '',
    codeword: '',
    accessCode: null,
    checkIn: null,
    checkOut: null,
    heroImage: null,
    accommodationNote: null,
    show: ['map', 'wifi', 'parking', 'gardens', 'dining', 'taxi', 'facilities'],
  });
}

export const DEFAULT_ARRIVAL_MARKDOWN = `\
## Welcome

We're delighted to welcome you to Ashridge House. Please find all the information you need for your arrival below.

---

## Teaching Room

Your sessions will take place in **[Room name]**.

[Add any additional details about the room location or access here.]

`;
